import { render } from "./Logout.vue?vue&type=template&id=1ca063f9"
import script from "./Logout.vue?vue&type=script&lang=js"
export * from "./Logout.vue?vue&type=script&lang=js"

import exportComponent from "/home/gp/git/git.glitchedpolygons.ch/locales.glitchedpolygons.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__